import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useAchievementStatus, useUpdatePrivacy } from '../../features/achievement';
import UsageTracker from '../../utils/UsageTracker';
import { cleanTrackingProps } from '../../utils/awardTrackingUtils';
import { useFullChirpTrack } from '../../features/tracks';
import { jsx as _jsx } from "react/jsx-runtime";
const AwardVisibilityToggle = ({
  onToggle,
  checked,
  disabled
}) => {
  const onChange = useCallback(({
    target: {
      checked: _checked
    }
  }) => {
    onToggle(!!_checked);
  }, [onToggle]);
  return /*#__PURE__*/_jsx(Toggle, {
    checked: checked,
    "data-test-id": "award-visibility-toggle",
    disabled: disabled,
    onChange: onChange,
    size: "small"
  });
};
const AwardVisibilityToggleContainer = ({
  award,
  disabledTooltip,
  isFetchingAchievements,
  trackId
}) => {
  const {
    updatePrivacy,
    updatePrivacyLoading
  } = useUpdatePrivacy({
    trackId,
    awardCode: award.code,
    shouldBePublic: award.visibility !== 'PUBLIC'
  });
  const {
    track,
    trackLoading
  } = useFullChirpTrack(trackId);
  const {
    isPrivate
  } = useAchievementStatus(trackId);
  const onToggle = useCallback(shouldBePublic => {
    var _track$name;
    const privacy = shouldBePublic ? 'PUBLIC' : 'PRIVATE';
    updatePrivacy();
    UsageTracker.trackStandalone('Award Interaction', cleanTrackingProps({
      action: 'toggle-privacy',
      type: 'certification',
      name: (_track$name = track === null || track === void 0 ? void 0 : track.name) !== null && _track$name !== void 0 ? _track$name : '',
      privacy,
      trackName: track === null || track === void 0 ? void 0 : track.name,
      trackId: trackId.toString()
    }));
  }, [track, trackId, updatePrivacy]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: isPrivate ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: disabledTooltip
    }) : null,
    children: /*#__PURE__*/_jsx("div", {
      "data-loading": updatePrivacyLoading || isFetchingAchievements || trackLoading,
      children: /*#__PURE__*/_jsx(AwardVisibilityToggle, {
        checked: !isPrivate,
        disabled: updatePrivacyLoading || isFetchingAchievements,
        onToggle: onToggle
      })
    })
  });
};
export default AwardVisibilityToggleContainer;